module.exports = __webpack_public_path__ + "img/CT.Bridges.Parapets_.Steel_Parapet_(N2).Steel.b671c968.png";